import script from "./BuySocks4.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuySocks4.vue?vue&type=script&setup=true&lang=ts"

import "../../assets/css/buy-proxies.css?vue&type=style&index=0&id=0895708e&scoped=true&lang=css"

import exportComponent from "/home/windows/Documents/workspace/proxyscrape-project/proxyscrape-website-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0895708e"]])

export default __exports__